import { Box } from '@mui/material';
import React from 'react';

export interface DetailListItemProps {
  label?: React.ReactNode;
  content?: React.ReactNode;
  className?: string;
}

export const DetailListItem = ({
  label,
  content,
  className,
}: DetailListItemProps) => {
  return (
    <Box className={className} component="li" display="flex" pt={1} pb={1}>
      <Box>{label}</Box>
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Box>{content}</Box>
      </Box>
    </Box>
  );
};
